// Centralised data-testid tokens for PrepHacker Connect.
// Naming: <page>-<component>-<element>

export const LOGIN = {
  email: "login-email-input",
  password: "login-password-input",
  submit: "login-submit-btn",
  error: "login-error-msg",
};

export const NAV = {
  sidebar: "app-sidebar",
  linkDashboard: "nav-dashboard-link",
  linkUsers: "nav-users-link",
  linkCadence: "nav-cadence-link",
  linkGuardrails: "nav-guardrails-link",
  linkKB: "nav-kb-link",
  linkTemplates: "nav-templates-link",
  linkWaNumbers: "nav-wa-numbers-link",
  linkDigests: "nav-digests-link",
  linkAudit: "nav-audit-link",
  linkTeam: "nav-team-link",
  linkAIControl: "nav-ai-control-link",
  linkSettings: "nav-settings-link",
  linkLabels: "nav-labels-link",
  linkAITimings: "nav-ai-timings-link",
  linkAIConnectors: "nav-ai-connectors-link",
  linkStatistics: "nav-statistics-link",
  logout: "nav-logout-btn",
  userBadge: "nav-user-badge",
  globalSearch: "nav-global-search",
  askConnectBtn: "nav-ask-connect-btn",
};

export const DASHBOARD = {
  root: "dashboard-root",
  statTotal: "dashboard-stat-total",
  statTrial: "dashboard-stat-trial",
  statPaid: "dashboard-stat-paid",
  statConversion: "dashboard-stat-conversion",
  funnelDay1: "funnel-day1",
  funnelDay2: "funnel-day2",
  funnelDay3: "funnel-day3",
  funnelActive: "funnel-active",
  funnelInactive: "funnel-inactive",
  syncBtn: "dashboard-sync-btn",
  generateDigestBtn: "dashboard-generate-digest-btn",
  topLeadsCard: "dashboard-top-leads",
  activityCard: "dashboard-activity",
};

export const USERS = {
  root: "users-root",
  searchInput: "users-search-input",
  statusFilter: "users-status-filter",
  syncBtn: "users-sync-btn",
  table: "users-table",
  rowPrefix: "users-row-",
  openRow: "users-open-row-",
};

export const USER_DETAIL = {
  root: "user-detail-root",
  chatTimeline: "user-chat-timeline",
  messageInput: "user-message-input",
  channelToggle: "user-channel-toggle",
  sendBtn: "user-send-btn",
  draftBtn: "user-draft-btn",
  takeoverToggle: "user-takeover-toggle",
  simulateInboundBtn: "user-simulate-inbound-btn",
  scoreBadge: "user-score-badge",
  tagsChips: "user-tags-chips",
  addTagBtn: "user-add-tag-btn",
  dndToggle: "user-dnd-toggle",
  dndReasonInput: "user-dnd-reason-input",
  nextActionBadge: "user-next-action-badge",
  nextActionCountdown: "user-next-action-countdown",
  // CPS V2 (Stage 5) — Shadow scoring intelligence
  cpsV2Panel: "cps-v2-panel",
  cpsV2Score: "cps-v2-score",
  cpsV2Readiness: "cps-v2-readiness",
  cpsV2Confidence: "cps-v2-confidence",
  cpsV2ProvisionalBadge: "cps-v2-provisional-badge",
  cpsV2LegacyBadge: "cps-v2-legacy-badge",
  cpsV2ShadowLabel: "cps-v2-shadow-label",
  cpsV2WhyBtn: "cps-v2-why-btn",
  cpsV2BreakdownDrawer: "cps-v2-breakdown-drawer",
  cpsV2ComparisonToggle: "cps-v2-comparison-toggle",
  cpsV2HistoryPanel: "cps-v2-history-panel",
  cpsV2HistoryLoadMore: "cps-v2-history-load-more",
  cpsTrendChart: "cps-trend-chart",
  cpsTrendRange: "cps-trend-range",
};

export const AI_CONTROL_CPS = {
  root: "ai-control-cps-v2-root",
  modeBadge: "ai-control-cps-mode-badge",
  activateShadowBtn: "ai-control-cps-activate-shadow-btn",
  revertLegacyBtn: "ai-control-cps-revert-legacy-btn",
  activateV2Btn: "ai-control-cps-activate-v2-btn",
  daysElapsed: "ai-control-cps-days-elapsed",
  fullFidelityCount: "ai-control-cps-full-fidelity-count",
  provisionalCount: "ai-control-cps-provisional-count",
  uniqueUsers: "ai-control-cps-unique-users",
  readyBadge: "ai-control-cps-ready-badge",
};

export const BEHAVIOR_SIGNALS = {
  root: "behavior-signals-root",
  refreshBtn: "behavior-signals-refresh-btn",
  signalCard: "behavior-signal-card",
  operationalBadge: "behavior-signal-operational-badge",
  trackingToggle: "behavior-signal-tracking-toggle",
  enabledToggle: "behavior-signal-enabled-toggle",
  saveBtn: "behavior-signal-save-btn",
  minAndroidInput: "behavior-signal-min-android-input",
  miniOsInput: "behavior-signal-min-ios-input",
  totalEvents: "behavior-signal-total-events",
  eventsToday: "behavior-signal-events-today",
  events7d: "behavior-signal-events-7d",
  uniqueUsers: "behavior-signal-unique-users",
  rejectedCount: "behavior-signal-rejected-count",
  platforms: "behavior-signal-platforms",
  versions: "behavior-signal-versions",
};

export const LABELS = {
  root: "labels-root",
  addBtn: "labels-add-btn",
  saveBtn: "labels-save-btn",
  slugInput: "labels-slug-input",
  nameInput: "labels-name-input",
  descInput: "labels-desc-input",
  colorSelect: "labels-color-select",
  aiManagedToggle: "labels-ai-managed-toggle",
  rowPrefix: "labels-row-",
};

export const CADENCE = {
  root: "cadence-root",
  addStepBtn: "cadence-add-step-btn",
  saveBtn: "cadence-save-btn",
  stepPrefix: "cadence-step-",
  tabPrefix: "cadence-tab-",
  addCadenceBtn: "cadence-add-cadence-btn",
  deleteCadenceBtn: "cadence-delete-cadence-btn",
};

export const AI_TIMINGS = {
  root: "ai-timings-root",
  firstPush: "ai-timings-first-push",
  day1Sla: "ai-timings-day1-sla",
  day2Sla: "ai-timings-day2-sla",
  day3Sla: "ai-timings-day3-sla",
  cooldown: "ai-timings-cooldown",
  hotLead: "ai-timings-hot-lead",
  postConv: "ai-timings-post-conv",
  winBack: "ai-timings-win-back",
  saveBtn: "ai-timings-save-btn",
};

export const AI_CONNECTORS = {
  root: "ai-connectors-root",
  addBtn: "ai-connectors-add-btn",
  saveBtn: "ai-connectors-save-btn",
  kindSelect: "ai-connectors-kind-select",
  nameInput: "ai-connectors-name-input",
  modelInput: "ai-connectors-model-input",
  keyInput: "ai-connectors-key-input",
  rowPrefix: "ai-connectors-row-",
  testBtn: "ai-connectors-test-btn",
  activateBtn: "ai-connectors-activate-btn",
  routingRoot: "ai-routing-root",
  routingSelectPrefix: "ai-routing-select-",
  routingSaveBtn: "ai-routing-save-btn",
  usageRoot: "ai-usage-root",
  usageDaysSelect: "ai-usage-days-select",
};

export const AI_CONTROL_QUICK_SWITCH = {
  select: "ai-control-active-connector-select",
};

export const STATISTICS = {
  root: "statistics-root",
  daysSelect: "statistics-days-select",
  exportXlsx: "statistics-export-xlsx-btn",
  exportPdf: "statistics-export-pdf-btn",
  cardTotal: "statistics-card-total",
  cardPaid: "statistics-card-paid",
  cardTrial: "statistics-card-trial",
  cardConversion: "statistics-card-conversion",
  cardDnd: "statistics-card-dnd",
  cardAiPaused: "statistics-card-ai-paused",
  chartSignups: "statistics-chart-signups",
  chartConversions: "statistics-chart-conversions",
  chartMessages: "statistics-chart-messages",
  chartFunnel: "statistics-chart-funnel",
  chartLabels: "statistics-chart-labels",
  chartAIUsage: "statistics-chart-ai-usage",
  refreshBtn: "statistics-refresh-btn",
};

export const GUARDRAILS = {
  root: "guardrails-root",
  policiesTextarea: "guardrails-policies-textarea",
  forbiddenInput: "guardrails-forbidden-input",
  escalationInput: "guardrails-escalation-input",
  libertySlider: "guardrails-liberty-slider",
  maxPerDayInput: "guardrails-maxperday-input",
  saveBtn: "guardrails-save-btn",
};

export const KB = {
  root: "kb-root",
  addBtn: "kb-add-btn",
  saveBtn: "kb-save-btn",
  itemPrefix: "kb-item-",
};

export const TEMPLATES = {
  root: "templates-root",
  addBtn: "templates-add-btn",
  saveBtn: "templates-save-btn",
  itemPrefix: "templates-item-",
};

export const WA_NUMBERS = {
  root: "wa-numbers-root",
  addBtn: "wa-numbers-add-btn",
  saveBtn: "wa-numbers-save-btn",
  itemPrefix: "wa-numbers-item-",
};

export const DIGESTS = {
  root: "digests-root",
  generateDailyBtn: "digests-generate-daily-btn",
  generateWeeklyBtn: "digests-generate-weekly-btn",
  itemPrefix: "digests-item-",
};

export const AUDIT = {
  root: "audit-root",
  actionFilter: "audit-action-filter",
  table: "audit-table",
};

export const STAFF = {
  root: "staff-root",
  addBtn: "staff-add-btn",
  emailInput: "staff-email-input",
  nameInput: "staff-name-input",
  passwordInput: "staff-password-input",
  roleSelect: "staff-role-select",
  saveBtn: "staff-save-btn",
  rowPrefix: "staff-row-",
};

export const AI_CONTROL = {
  root: "ai-control-root",
  killSwitch: "ai-control-kill-switch",
  cadenceToggle: "ai-control-cadence-toggle",
  draftingToggle: "ai-control-drafting-toggle",
  scoringToggle: "ai-control-scoring-toggle",
  digestsToggle: "ai-control-digests-toggle",
  assistantToggle: "ai-control-assistant-toggle",
  assistantWriteToggle: "ai-control-assistant-write-toggle",
  escalationPauseToggle: "ai-control-escalation-pause-toggle",
};

export const SETTINGS = {
  root: "settings-root",
  timezoneSelect: "settings-timezone-select",
  syncEnabled: "settings-sync-enabled",
  syncInterval: "settings-sync-interval",
  digestDailyTime: "settings-digest-daily-time",
  digestWeeklyDow: "settings-digest-weekly-dow",
  digestWeeklyTime: "settings-digest-weekly-time",
  cadenceTick: "settings-cadence-tick",
  saveBtn: "settings-save-btn",
};

export const ASSISTANT = {
  bubble: "assistant-bubble",
  panel: "assistant-panel",
  input: "assistant-input",
  sendBtn: "assistant-send-btn",
  confirmBtn: "assistant-confirm-btn",
  cancelBtn: "assistant-cancel-btn",
  closeBtn: "assistant-close-btn",
};
